var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.95 11.05C20.559 10.66 19.926 10.66 19.536 11.05L16 14.59L12.464 11.05C12.074 10.66 11.441 10.66 11.05 11.05C10.66 11.44 10.66 12.07 11.05 12.46L14.586 16L11.05 19.54C10.66 19.93 10.66 20.56 11.05 20.95C11.441 21.34 12.074 21.34 12.464 20.95L16 17.41L19.536 20.95C19.926 21.34 20.559 21.34 20.95 20.95C21.34 20.56 21.34 19.93 20.95 19.54L17.414 16L20.95 12.46C21.34 12.07 21.34 11.44 20.95 11.05ZM30 28C30 29.1 29.104 30 28 30H4C2.896 30 2 29.1 2 28V4C2 2.9 2.896 2 4 2H28C29.104 2 30 2.9 30 4V28ZM28 0H4C1.791 0 0 1.79 0 4V28C0 30.21 1.791 32 4 32H28C30.209 32 32 30.21 32 28V4C32 1.79 30.209 0 28 0Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9121fdcbc77b20733fec23a24cc43b82.svg";
export { ForwardRef as ReactComponent };